import Immutable from "immutable";

import { getResource } from "selectors/resources";
import { Features } from "resourceModels/Client";
import { TypedMap } from "types";
import BaseMessageRecord, {
  BaseMessageRecordAttributes,
  BlockConfigGetter
} from "../BaseMessageRecord";

export type QuickRepliesMessageRecordQuickReply = TypedMap<{
  target: string
}>

interface QuickRepliesMessageRecordAttributes extends BaseMessageRecordAttributes {
  quickReplies?: Immutable.List<QuickRepliesMessageRecordQuickReply>;
}

class QuickRepliesMessageRecord extends BaseMessageRecord<QuickRepliesMessageRecordAttributes>({
  type: "quick_replies_block",
  quickReplies: Immutable.List()
}) {
  static blockConfig: BlockConfigGetter = state => ({
    isVisible: getResource(state, "client").hasFeature(Features.QUICK_REPLIES_BLOCK),
    icon: "QuickReplies",
    blockName: "Quick Replies",
    blockTitle: "Quick Replies",
    shortTitle: "Quick Replies",
    blockType: "action"
  })
}

/**
 * Validation
 */

QuickRepliesMessageRecord.getInvalidFields = (
  message: QuickRepliesMessageRecord
): Immutable.List<string> => {
  const invalidFields: Set<string> = new Set();

  if (message.quickReplies.isEmpty()) {
    invalidFields.add("quickReplies");
  }

  return Immutable.List(invalidFields);
};

export default QuickRepliesMessageRecord;
